import '../interaction_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.ReviewComment

  initialize: (data) ->
    @data = data

  constructor: (data) ->
    @data = data

  data: ->
   return @data

  getJson: ->
    @data

  links: ->
    []

  username: ->
    if @data.userComment.userName != ""
        @data.userComment.userName
    else
      I18n.t('google_play.user.anonymous')

  getUserType: ->
    return @data.userType

  appName: ->
    return @data.app_id

  userComment: ->
    return @data.userComment

  appVersion: ->
    if @data.comment.appVersionName
     @data.comment.appVersionName
    else
      I18n.t('google_play.version.unknown')

  contentUrl: ->
    @link()

  link: ->
    "https://play.google.com/store/apps/details?id=#{@data.app_id}&reviewId=#{@data.reviewId}"

  getAvatar: ->
    if @data.userType == "owner" then window.image_path('gpdev-ico.png') else window.image_path('gplay.png')

  getCreatedAt: ->
    if this.data.created_at
      Date.create (@data.created_at)
    else
      Date.create(@data.interaction.created_at)

  starRating: ->
    @data.comment.starRating

  getSubType: ->
    'gp_review_comment'

  getType: ->
    'google_play'

  getGroupType: ->
    'google_play'

  getPrivacy: ->
    'private'

  getMainText: ->
    if @data.text
      @data.text
    else
      @data.interaction.content

  getContentId: ->
    @data.content_id || @data.interaction_id

  isBrandContent: ->
    @data.userType == "owner"

  isDeveloperComment:->
    @data.userType == "owner"

  hasUser: ->
    true

  hasProfile: ->
    @authorName() != ""

  hasRelated: ->
    false

  getAuthorId: ->
    @data.interaction.author.id

  getAuthorName: ->
    if @authorName() != ""
      @authorName()
    else
       I18n.t('google_play.user.anonymous')

  isAnonymousUser: ->
    return @authorName() == ""

  getAuthorUsername: ->
    '' #temporary fix. check merge issues

  avatar: ->
    if @data.userType == "owner" then window.image_path('gpdev-ico.png') else window.image_path('gplay.png')

  authorName: ->
    if @data.authorName
        @data.authorName
    else
      @data.interaction.author.name


  type: ->
    @getType()

  getValue: (name) ->
    return @getValues()[name]

  getValues: ->
    return @get('data').content
